import { render, staticRenderFns } from "./QuoteComponent.vue?vue&type=template&id=64f13ebc&scoped=true"
import script from "./QuoteComponent.vue?vue&type=script&lang=js"
export * from "./QuoteComponent.vue?vue&type=script&lang=js"
import style0 from "./QuoteComponent.vue?vue&type=style&index=0&id=64f13ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f13ebc",
  null
  
)

export default component.exports